import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CheckBlockService } from '../../../check-block/check-block.service';
import { ICheckBlock } from '../../../check-block/interface/check-block.interface';
import { ISample } from '../../../samples/interface/sample.interface';
import { SamplesService } from '../../../samples/service/samples.service';
import { ICheckBlockRaisedUserNotification } from '../../notification.type';
import { NOTIFICATION_INPUT } from '../../notifications.type';
import { NotificationsService } from '../../notifications.service';

@Component({
  standalone: true,
  imports: [RouterModule, MatButtonModule],
  template: `
    <h3>Checkblock Assigned to You</h3>

    @if (checkBlock && sample) {
      <a
        mat-stroked-button
        [routerLink]="['/tows', sample.towId, 'samples', sample._id]"
        [queryParams]="{ checkblock: checkBlock._id, taxon: checkBlock.taxonId }"
        queryParamsHandling="merge"
        (click)="notificationService.setStatus(notification._id, 'read')"
      >
        {{ sample.oldSampleId }}
      </a>

      <p>{{ checkBlock.messages.at(-1)?.message || 'No checkblock message available.' }}</p>
    } @else {
      <button mat-stroked-button disabled>
        Checkblock unavailable ({{ notification.metadata.checkBlockId }})
      </button>

      <p>Linked sample unavailable.</p>
    }
  `,
})
export class CheckBlockAssignedToYouNotificationComponent {
  readonly checkblockService = inject(CheckBlockService);
  readonly notificationService = inject(NotificationsService);
  readonly sampleService = inject(SamplesService);

  readonly notification = inject<ICheckBlockRaisedUserNotification>(NOTIFICATION_INPUT);

  protected checkBlock: ICheckBlock | null = null;
  protected sample: ISample | null = null;

  async ngOnInit() {
    try {
      this.checkBlock = await this.checkblockService.get(this.notification.metadata.checkBlockId);

      if (this.checkBlock?.sampleId) {
        this.sample = await this.sampleService.getOne('', this.checkBlock.sampleId);
      }
    } catch {
      this.checkBlock = null;
      this.sample = null;
    }
  }
}
